// API Configuration
const API_CONFIG = {
  // Backend API Base URL
  BASE_URL: process.env.REACT_APP_API_URL || 'https://probillrcm.com',

  // API Endpoints
  ENDPOINTS: {
    CONTACT: '/api/contact',
    HEALTH: '/api/health',
    BLOGS: '/api/blogs',
  },

  // API Timeout (in milliseconds)
  TIMEOUT: 10000,

  // Headers
  HEADERS: {
    'Content-Type': 'application/json',
  },
};

// Helper function to get full API URL
export const getApiUrl = (endpoint) => {
  return `${API_CONFIG.BASE_URL}${endpoint}`;
};

// Helper function to get contact API URL
export const getContactApiUrl = () => {
  return getApiUrl(API_CONFIG.ENDPOINTS.CONTACT);
};

// Helper function to get health check API URL
export const getHealthApiUrl = () => {
  return getApiUrl(API_CONFIG.ENDPOINTS.HEALTH);
};

export default API_CONFIG; 